import { render, staticRenderFns } from "./EditCompanyIntroduce.vue?vue&type=template&id=940dcda8&"
import script from "./EditCompanyIntroduce.vue?vue&type=script&lang=js&"
export * from "./EditCompanyIntroduce.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports